/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards from '../../components/MisconceptionCards';
import FlipCardGrid from '../../components/FlipCardGrid';
import { MC_ICONS, FCG_ICONS } from './iconMap';
import DoDontCards from '../../components/DoDontCards';
import fcgImg1 from '../../../../../../assets/student-training/AIns/img-step1.png';
import fcgImg2 from '../../../../../../assets/student-training/AIns/img-step2.png';
import fcgImg3 from '../../../../../../assets/student-training/AIns/img-step3.png';
import fcgImg4 from '../../../../../../assets/student-training/AIns/img-step4.png';
import doImg from '../../../../../../assets/student-training/AIns/do.png';
import dontImg from '../../../../../../assets/student-training/AIns/dont.png';
import { CTitle } from '../../components/Widget';
interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();

  const doColumn = useMemo(
    () => ({
      title: paragraphsSettings?.doTitle,
      image: doImg,
      items: paragraphsSettings?.doList ?? [],
    }),
    [paragraphsSettings?.doTitle, paragraphsSettings?.doList]
  );

  const dontColumn = useMemo(
    () => ({
      title: paragraphsSettings?.dontTitle,
      image: dontImg,
      items: paragraphsSettings?.dontList ?? [],
    }),
    [paragraphsSettings?.dontTitle, paragraphsSettings?.dontList]
  );

  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-AIns-section2-2'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  const handleFlipCardGridComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-AIns-section2-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  const FCG_IMAGES = [fcgImg1, fcgImg2, fcgImg3, fcgImg4];
  const FCG_ITEMS = useMemo(() => {
    return (
      paragraphsSettings?.FCGItems?.map((item: any, index: number) => ({
        icon: FCG_ICONS[index](false),
        title: item.title,
        illustration: <img src={FCG_IMAGES[index]} alt="" />,
        content: item.content,
      })) ?? []
    );
  }, [paragraphsSettings, FCG_ICONS]);

  return (
    <div className="topic-section-2">
      <FlipCardGrid
        mainTitle={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.FCGSubTitle}
        description={paragraphsSettings?.FCGDesc}
        items={FCG_ITEMS}
        defaultActiveIndex={0}
        id="student-training-AIns-section2-1"
        onComplete={handleFlipCardGridComplete}
      />
      <MisconceptionCards
        subTitle={paragraphsSettings?.MCTitle}
        tips={paragraphsSettings?.MCDesc}
        items={paragraphsSettings?.MCRisks}
        icons={MC_ICONS}
        id="student-training-AIns-section2-2"
        onComplete={handleMisconceptionCardsComplete}
      />
      <CTitle title={paragraphsSettings?.doDontTitle} />
      <DoDontCards doColumn={doColumn} dontColumn={dontColumn} />
    </div>
  );
};

export default React.memo(Section2);
